<template>
  <a class="button-link">
    <slot />
    <svg width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L4.5 4.5L1 8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </a>
</template>

<script>
export default {
  name: 'ButtonLink'
}
</script>

<style scoped>
  .svg-icon {
    width: 100%;
    height: 100%;
    fill: #c2d1d9;
  }
</style>



// WEBPACK FOOTER //
// src/components/assetComponents/ButtonLink.vue